import React from "react";
import Flatpickr from "react-flatpickr";

export default function LeadControlBar({
  filterKey,
  setFilterKey,
  filterValue,
  setFilterValue,
  viewMode,
  setViewMode,
  limit,
  onChangeLimit,
  onOpenCreate,
  onOpenBulk,
  onExport,
}) {
  return (
    <div className="card mb-4 mt-3" style={{ fontSize: "0.9rem" }}>
      <div className="card-body p-3">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
          {/* Left: Filter */}
          <div className="flex-grow-1">
            <div className="row g-2">
              <div className="col-md-4">
                <div className="form-floating">
                  <select
                    id="filterKey"
                    className="form-select"
                    value={filterKey}
                    onChange={(e) => {
                      setFilterKey(e.target.value);
                      setFilterValue("");
                    }}
                  >
                    <option value="phone">Phone Number</option>
                    <option value="name">Name</option>
                    <option value="status">Status</option>
                    <option value="createdAt">Added Date</option>
                  </select>
                  <label htmlFor="filterKey">Filter By</label>
                </div>
              </div>

              <div className="col-md-8">
                {filterKey === "status" ? (
                  <div className="form-floating">
                    <select
                      id="statusSelect"
                      className="form-select"
                      value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}
                    >
                      <option value="">All Status</option>
                      <option value="No Status">No Status</option>
                      <option value="Follow Up">Follow Up</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Booking">Booking</option>
                      <option value="Closed">Closed</option>
                    </select>
                    <label htmlFor="statusSelect">Select Status</label>
                  </div>
                ) : filterKey === "createdAt" ? (
                  <div className="form-floating">
                    <Flatpickr
                      className="form-control"
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                        disableMobile: true,
                      }}
                      placeholder="Select date range"
                      value={
                        filterValue.includes(" to ")
                          ? filterValue.split(" to ").map((d) => new Date(d))
                          : []
                      }
                      onChange={(selectedDates) => {
                        if (selectedDates.length === 2) {
                          const fmt = (date) =>
                            `${date.getFullYear()}-${String(
                              date.getMonth() + 1
                            ).padStart(2, "0")}-${String(date.getDate()).padStart(
                              2,
                              "0"
                            )}`;
                          setFilterValue(
                            `${fmt(selectedDates[0])} to ${fmt(selectedDates[1])}`
                          );
                        } else {
                          setFilterValue("");
                        }
                      }}
                    />
                    <label style={{ color: "grey" }}>Select Date Range</label>
                  </div>
                ) : (
                  <div className="form-floating">
                    <input
                      type="text"
                      id="filterInput"
                      className="form-control"
                      placeholder={`Search By ${filterKey}`}
                      value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}
                    />
                    <label
                      htmlFor="filterInput"
                      style={{ color: "grey" }}
                    >{`Search by ${
                      filterKey.charAt(0).toUpperCase() + filterKey.slice(1)
                    }`}</label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right: Actions */}
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
            <div className="btn-group">
              <button
                className="btn btn-outline-success"
                type="button"
                onClick={onOpenCreate}
              >
                + New
              </button>
              <button
                className="btn btn-outline-success"
                type="button"
                onClick={onOpenBulk}
              >
                <i className="bi bi-upload me-1"></i> Bulk
              </button>
            </div>

            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={onExport}
              title="Export current list to Excel"
            >
              <i className="bi bi-download"></i>
            </button>

            {/* View toggle */}
            <div className="btn-group ms-1" role="group">
              <button
                type="button"
                className={`btn btn-sm ${
                  viewMode === "card"
                    ? "btn-secondary"
                    : "btn-outline-secondary"
                }`}
                onClick={() => setViewMode("card")}
              >
                <i className="bi bi-grid-3x3-gap-fill me-1"></i>Card
              </button>
              <button
                type="button"
                className={`btn btn-sm ${
                  viewMode === "table"
                    ? "btn-secondary"
                    : "btn-outline-secondary"
                }`}
                onClick={() => setViewMode("table")}
              >
                <i className="bi bi-table me-1"></i>Table
              </button>
            </div>

            {/* Limit */}
            <div className="d-flex flex-column align-items-end ms-2">
              <span
                className="text-muted"
                style={{ fontSize: "0.75rem", fontStyle: "italic" }}
              >
                Leads / page
              </span>
              <select
                className="form-select form-select-sm w-auto"
                value={limit}
                onChange={(e) => onChangeLimit(Number(e.target.value))}
                >
                <option value={26}>26</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={0}>All</option>
                </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
